var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Observable } from 'rxjs';
export function defineProcedure(procedure) {
    var procName = procedure.procName, actionFn = procedure.actionFn, _a = procedure.aliases, aliases = _a === void 0 ? [] : _a, mapFnIn = procedure.mapFnIn, mapFnOut = procedure.mapFnOut;
    var defineCallback = function (params) {
        var self = this;
        // map to model
        var procParam = mapFnIn ? mapFnIn(params) : params;
        var procReturnValue = actionFn(procParam);
        if (typeof procReturnValue === 'undefined') {
            return;
        }
        // publish result
        if (procReturnValue instanceof Observable) {
            var procReturnValue$ = procReturnValue;
            procReturnValue$.subscribe(function (value) {
                var out = mapFnOut ? mapFnOut(value) : value;
                self.setResult(out);
            });
        }
        else {
            var out = mapFnOut ? mapFnOut(procReturnValue) : procReturnValue;
            self.setResult(out);
        }
    };
    var procNames = __spread([procName], aliases);
    procNames.forEach(function (_procName) { return Human.rpc.define(_procName, defineCallback); });
}
